import React from 'react';
import LinkifyIt from 'linkify-it';
import tlds from 'tlds';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { BaseProps } from '../common/props';

interface FormattedTextProps extends Omit<BaseProps, 'children'> {
  text?: string;
  children?: React.ReactNode;
}

export const FormattedText: React.FC<FormattedTextProps> = ({
  text,
  className,
  children,
  ...other
}) => {
  const parseString = (string?: string) => {
    if (!string) {
      return string;
    }

    const linkify = new LinkifyIt();
    linkify.tlds(tlds);

    const matches = linkify.match(string);
    if (!matches) {
      return string;
    }

    const elements = [];
    let lastIndex = 0;
    // @ts-ignore
    matches.forEach((match, i) => {
      // Push preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(string.substring(lastIndex, match.index));
      }

      elements.push(
        <a key={i} href={match.url} target="_blank" rel="noopener noreferrer">
          {match.text}
        </a>
      );

      lastIndex = match.lastIndex;
    });

    // Push remaining text if there is any
    if (string.length > lastIndex) {
      elements.push(string.substring(lastIndex));
    }

    return elements.length === 1 ? elements[0] : elements;
  };

  // @ts-ignore
  // const parse = (children: any, key: number = 0) => {
  //   if (typeof children === 'string') {
  //     return parseString(children);
  //   } else if (
  //     React.isValidElement(children) &&
  //     children.type !== 'a' &&
  //     children.type !== 'button'
  //   ) {
  //     return React.cloneElement(
  //       children,
  //       { key: key },
  //       // @ts-ignore
  //       parse(children.props.children)
  //     );
  //   } else if (Array.isArray(children)) {
  //     return children.map((child, i) => parse(child, i));
  //   }
  //
  //   return children;
  // };

  // return text || children ? (
  return text ? (
    <span className={classNames(Classes.FORMATTED_TEXT, className)} {...other}>
      {parseString(text)}
      {/*{parse(children)}*/}
    </span>
  ) : null;
};
